import { render, staticRenderFns } from "./SendEmailModel.vue?vue&type=template&id=9bb70264&scoped=true&"
import script from "./SendEmailModel.vue?vue&type=script&lang=js&"
export * from "./SendEmailModel.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailModel.vue?vue&type=style&index=0&id=9bb70264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb70264",
  null
  
)

export default component.exports